import { styled } from '@mui/material';
import { CourseCard, NoCourses } from 'components/CourseDashboard';
import { Button, Container, Icon, IconButton, Loading, Stack, Text, TextInput } from 'shell/components';

const Mobile = ({
    courses,
    filteredCourses,
    startCourseSetup,
    searchBarInput,
    onChangeSearchBarInput,
    filterKey,
    setIsFilterDrawerOpen,
    selectCourse,
    handleCourseCardDropdown,
}) => {
    if (!courses) return <Loading />;

    return (
        <Container device={'mobile'}>
            <Stack sx={{ width: '100%' }} spacing={4}>
                <HeaderStack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
                    <Text component={'h1'} variant={'h6'} weight={'medium'}>
                        Courses
                    </Text>
                    <IconButton
                        aria-label={'create course'}
                        className={'joyride-step-1'}
                        kind={'add'}
                        size={'small'}
                        variant={'circle'}
                        onClick={startCourseSetup}
                    />
                </HeaderStack>
                <HeaderStack alignItems={'center'} direction={'row'} justifyContent={'space-between'} spacing={4}>
                    <Button
                        color={'neutral'}
                        startIcon={<Icon kind={'filter'} />}
                        variant={'secondary'}
                        onClick={() => setIsFilterDrawerOpen(true)}
                    >
                        ({filterKey.length})
                    </Button>
                    <CustomTextInput
                        disablePointerEventsOnIcon={!Boolean(searchBarInput)}
                        endIcon={
                            searchBarInput ? (
                                <IconButton
                                    aria-label={'clear search input'}
                                    kind={'exit'}
                                    variant={'square'}
                                    onClick={() => onChangeSearchBarInput('')}
                                    onMouseDown={(e) => e.preventDefault()}
                                />
                            ) : (
                                <Icon kind={'search'} />
                            )
                        }
                        placeholder={'Search'}
                        value={searchBarInput}
                        onChange={(e) => onChangeSearchBarInput(e.target.value)}
                    />
                </HeaderStack>
                {!courses.length ? (
                    <NoCourses />
                ) : (
                    <CoursesStack alignItems={'flex-start'} direction={'row'} justifyContent={'flex-start'} spacing={3}>
                        {filteredCourses.map((course, index) => {
                            return (
                                <CourseCard
                                    key={course.course_id}
                                    className={!index ? 'joyride-step-2' : undefined}
                                    course={course}
                                    handleCourseCardDropdown={handleCourseCardDropdown}
                                    onClick={selectCourse}
                                />
                            );
                        })}
                    </CoursesStack>
                )}
            </Stack>
        </Container>
    );
};

const HeaderStack = styled(Stack)(() => {
    return {
        width: '100%',
    };
});

const CoursesStack = styled(Stack)(() => {
    return {
        flexWrap: 'wrap',
        width: '100%',
    };
});

const CustomTextInput = styled(TextInput)(() => {
    return {
        width: '13.5rem',
    };
});

export default Mobile;
